import * as React from 'react'
import { useLocation } from 'react-router-dom'
import Analytics from '../analytics'

export const usePageTracking = () => {
  const location = useLocation()

  React.useEffect(() => {
    Analytics().page({ path: location.pathname })
  }, [location])
}

export default usePageTracking
